
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator";
import draggable from "vuedraggable";
import { HeaderColumn } from "../config/list";
import EllipShow from "@/components/ellipShow.vue";

@Component({
  components: {
    draggable,
    EllipShow
  }
})
export default class TableSortDialog extends Vue {
  @Prop() showSortSetting!: boolean;
  @Prop() headerList!: HeaderColumn[];
  @Prop() resetList!: HeaderColumn[];

  dropList: HeaderColumn[] = [];
  selectList: HeaderColumn[] = [];
  keyword = "";

  @Watch("selectList", { deep: true })
  getDrop(nval: HeaderColumn[]) {
    this.dropList = JSON.parse(JSON.stringify(nval));
  }

  onMove(e: any) {
    return e.relatedContext.element.respond !== false;
  }

  selectItem(item: HeaderColumn) {
    if (item.required) {
      return;
    }
    this.selectList.forEach(el => {
      if (el.label === item.label) {
        el.isShow = !el.isShow;
      }
    });
  }

  @Watch("headerList", { deep: true, immediate: true })
  getList(nval: HeaderColumn[]) {
    this.selectList = JSON.parse(JSON.stringify(nval));
  }

  reset() {
    this.dropList = JSON.parse(JSON.stringify(this.resetList));
    this.selectList = JSON.parse(JSON.stringify(this.resetList));
    this.getHeader();
  }

  cancel() {
    this.$emit("cancel");
  }

  @Emit()
  getHeader() {
    return this.dropList;
  }
}
